import { useState } from 'react';
import { Icon } from './Icon';
import { FAQS } from '../data';

export function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24" id="faq">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="reveal max-w-[680px] mx-auto mb-14 text-center">
          <span className="lp-eyebrow"><Icon name="message-circle" size={13} /> FAQ</span>
          <h2 className="text-[clamp(28px,3.6vw,42px)] font-bold tracking-[-0.03em] leading-[1.1] mt-4">Questions, answered</h2>
        </div>
        <div className="faq-list">
          {FAQS.map((f, i) => (
            <div className={`faq-item ${open === i ? 'open' : ''}`} key={i}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                {f.q}
                <Icon name="chevron-down" size={18} className="chev" />
              </button>
              <div className="faq-a">
                <div className="faq-a-inner">{f.a}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
